import { CaptchaModel, GetUserInfoModel, LoginParams, LoginResultModel } from './model/userModel';
import { ErrorMessageMode } from '/#/axios';
import { request } from '/@/utils/http/axios';

enum Api {
  Login = '/auth/login',
  Logout = '/auth/logout',
  GetUserInfo = '/user/info',
  GetPermCode = '/getPermCode',
  GetCaptcha = '/auth/captcha',
  GetBizList = '/auth/bizlist',
}

/**
 * @description: user login api
 */
export function loginApi(params: LoginParams, mode: ErrorMessageMode = 'modal') {
  return request.post<LoginResultModel>(
    {
      url: Api.Login,
      params,
    },
    {
      errorMessageMode: mode,
    },
  );
}

/**
 * @description: getUserInfo
 */
export function getUserInfo(mode: ErrorMessageMode = 'modal') {
  return request.get<GetUserInfoModel>(
    {
      url: Api.GetUserInfo
    },
    {
      errorMessageMode: mode
    }
  );
}

export function getPermCode(mode: ErrorMessageMode = 'modal') {
  return request.get<string[]>(
    {
      url: Api.GetPermCode
    },
    {
      errorMessageMode: mode
    }
  );
}

export function doLogout(mode: ErrorMessageMode = 'modal') {
  return request.get(
    {
      url: Api.Logout
    },
    {
      errorMessageMode: mode
    }
  );
}

export function getCaptcha(mode: ErrorMessageMode = 'modal') {
  return request.get<CaptchaModel>(
    {
      url: Api.GetCaptcha + '?t=' + new Date().getTime()
    },
    {
      errorMessageMode: mode
    },
  );
}

export function getBizList(mode: ErrorMessageMode = 'modal') {
  return request.get<any>(
    {
      url: Api.GetBizList + '?t=' + new Date().getTime()
    },
    {
      errorMessageMode: mode
    },
  );
}